import { Add, Send } from "@mui/icons-material";
import { IconButton, OutlinedInput, InputAdornment } from "@mui/material";
import { ChangeEvent, useCallback, useRef } from "react";

interface Props {
  value: string;
  setValue: (v: string) => void;
  isLoading: boolean;
  handleSubmit: () => void;
  setFile: (f: File | null) => void;
}

const ChatInput = ({
  value,
  setValue,
  handleSubmit,
  isLoading,
  setFile,
}: Props) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleQuestion = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setValue(event.target.value);
    },
    [setValue],
  );

  const handleFileChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const selected = e.target.files?.[0] ?? null;
      setFile(selected);
      e.target.value = "";
    },
    [setFile],
  );

  return (
    <OutlinedInput
      value={value}
      onChange={handleQuestion}
      id="outlined-adornment"
      type="text"
      multiline
      maxRows={10}
      minRows={3}
      placeholder="Type here..."
      startAdornment={
        <InputAdornment position="start" sx={{ mt: "auto" }}>
          <input
            ref={fileInputRef}
            type="file"
            hidden
            onChange={handleFileChange}
            accept=".pdf,.png,.jpg,.jpeg"
          />
          <IconButton
            sx={{ color: "#00B6B9" }}
            onClick={() => fileInputRef.current?.click()}
            disabled={isLoading}
          >
            <Add />
          </IconButton>
        </InputAdornment>
      }
      endAdornment={
        <IconButton
          loading={isLoading}
          sx={{ color: "#00B6B9", mt: "auto" }}
          onClick={handleSubmit}
          disabled={isLoading || value.length === 0}
        >
          <Send />
        </IconButton>
      }
    />
  );
};

export default ChatInput;
